import { ApiGetRequest } from '../../../api';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Report - Daily Check',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - Daily',
        href: '/adm/opr/report/daily-check',
        active: true,
      },
    ],
    showmodal: false,
    export: 0,
    detail: false,
    form: {
      id_user: '',
      name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportDailyCheck(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getExportReportDailyCheck({ commit, state }) {
    commit('reportDailyCheck', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      export: 1,
    };

    if (Array.isArray(data.form.date)) {
      params.start_date = data.form.date[0]
        ? moment(new Date(data.form.date[0])).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date[1]
        ? moment(new Date(data.form.date[1])).format('YYYY-MM-DD')
        : '';
    } else {
      if (data.form.date) {
        params.date = moment(new Date(data.form.date)).format('YYYY-MM-DD');
      }
    }

    let result = await ApiGetRequest(`opr/report/daily-check`, params);
    commit('reportDailyCheck', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      // var blob = new Blob([result.data], {
      //   type:
      //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      // });
      // var link = document.createElement('a');
      // link.href = window.URL.createObjectURL(blob);
      // link.download = 'report_daily.xlsx';

      // document.body.appendChild(link);

      // link.click();
      // document.body.removeChild(link);
      console.log(result, 'data result');
      return result.data.object || false;
    }
  },
};
